import { render } from "./입사지원서.vue?vue&type=template&id=180d60e7"
import script from "./입사지원서.vue?vue&type=script&lang=js"
export * from "./입사지원서.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__